export default (doc) => {

  let coverGallery = doc.coverGallery
  if (coverGallery && coverGallery.length) {
    coverGallery.forEach(item => {
      delete item.name
    })
  }


  let customGalleryArr = doc.gallery
  let floorPlanGallery = doc.floorPlanGallery
  if (floorPlanGallery && floorPlanGallery.length) {
    floorPlanGallery.forEach(item => {
      delete item.name
    })
  }
  let gallery = []




  if (customGalleryArr && Array.isArray(customGalleryArr) && customGalleryArr.length) {
    for (let item of customGalleryArr) {
      if (Array.isArray(item.photoList) && item.photoList.length) {
        for (let photo of item.photoList) {
          gallery.push({
            name: item.name,
            desp: item.desp,
            id: photo.id,
            url: photo.url,

          })
        }
      }
    }
  }

  let docGallery = []
  docGallery = coverGallery.concat(gallery).concat(floorPlanGallery)
  docGallery = docGallery.filter(item => item && item.url)

  return docGallery

  // let galleryArr = type === 'rental' ? doc.floorPlanGallery : doc.coverGallery
  // let customGalleryArr = doc.gallery





  // if (type === 'rental') {
  //   galleryArr = customGalleryArr.concat(galleryArr)
  // } else {
  //   galleryArr = galleryArr.concat(customGalleryArr)
  // }
  // const res = []
  // galleryArr.forEach(galleryObj => {
  //   if (!galleryObj) {
  //     return []
  //   }
  //   const name = galleryObj.name || ''
  //   const desp = galleryObj.desp || ''
  //   const subGalleryArr = galleryObj.photoList

  //   if (subGalleryArr) {
  //     subGalleryArr.forEach(subGalleryObj => {
  //       res.push({
  //         name,
  //         desp,
  //         id: subGalleryObj.id,
  //         url: subGalleryObj.url,
  //       })
  //     })
  //   } else if (galleryObj.url) {
  //     res.push({
  //       // 户型图只显示“户型图”这几个字
  //       name: 'Floorplan', // todo 多语言
  //       desp: '',
  //       id: galleryObj.id,
  //       url: galleryObj.url,
  //     })
  //   }
  // })
  // return res
}
